import React from 'react';
import { Tag } from '@ontruck/orc';

const t = {
  inactive: 'NOT ACTIVE',
};

const InactiveTag = ({ rowData, cellData }) => {
  if (!rowData) return;
  return !rowData.is_active ? (
    <Tag skin="modernGrey" weight="bold">
      {t.inactive}
    </Tag>
  ) : null;
};

export default InactiveTag;
